import { appConfig } from "@/config";

const DEFAULT_MENU = [
  { label: "Checker", href: "#checker", testid: "nav-link-checker" },
  { label: "How It Works", href: "#how-it-works", testid: "nav-link-how-it-works" },
  { label: "Features", href: "#features", testid: "nav-link-features" },
  { label: "Metrics", href: "#metrics", testid: "nav-link-metrics" },
];

const scrollTo = (id) => {
  document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
};

export const Navbar = () => {
  const menu = Array.isArray(appConfig.menu) && appConfig.menu.length ? appConfig.menu : DEFAULT_MENU;
  const logoUrl = appConfig.logoUrl || "logo_full.png";
  const ctaLabel = appConfig.ctaLabel || "Buy Backlink";
  const ctaUrl = appConfig.ctaUrl || "https://app.serpbacklink.com";

  return (
    <header
      data-testid="nav-container"
      className="fixed top-0 inset-x-0 z-50 backdrop-blur-xl bg-[#0B0F17]/80 border-b border-[#263248]"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 h-16 flex items-center justify-between">
        <button
          data-testid="nav-logo-link"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="flex items-center gap-2.5"
        >
          <img src={logoUrl} alt="serpbacklink" className="h-7 w-auto" />
        </button>
        <nav className="hidden md:flex items-center gap-7 font-mono2 text-xs uppercase tracking-[0.15em] text-[#9CA3AF]">
          {menu.map((item, i) =>
            item.href?.startsWith("#") ? (
              <button
                key={item.label}
                data-testid={item.testid || `nav-link-${i}`}
                onClick={() => scrollTo(item.href.slice(1))}
                className="hover:text-[#D4FF00] transition-colors"
              >
                {item.label}
              </button>
            ) : (
              <a
                key={item.label}
                data-testid={item.testid || `nav-link-${i}`}
                href={item.href}
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-[#D4FF00] transition-colors"
              >
                {item.label}
              </a>
            )
          )}
        </nav>
        <a
          data-testid="nav-cta-analyze-button"
          href={ctaUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="px-4 py-2 rounded-md bg-[#D4FF00] text-[#0B0F17] font-semibold text-sm hover:bg-[#E5FF66] active:bg-[#BCE600] transition-colors"
        >
          {ctaLabel}
        </a>
      </div>
    </header>
  );
};
